import { render, staticRenderFns } from "./CpD_Setting.vue?vue&type=template&id=04cfe1a0"
import script from "./CpD_Setting.vue?vue&type=script&lang=js"
export * from "./CpD_Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports